import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import {
  Link,
  Container,
  Typography,
  Divider,
  Stack,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Checkbox,
} from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { LoginForm } from '../sections/auth/login';
// ----------------------------------------------------------------------
import { BACK } from '../config';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');

  return (
    <>
      <Helmet>
        <title> 로그인 </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              주차실태 조사에 로그인하세요.
            </Typography>

            <Typography variant="body2" sx={{ mb: 5 }}>
              계정이 없다면 {''}
              <Link variant="subtitle2">관리자</Link> 에게 연락하세요.
            </Typography>

            <>
              <Stack spacing={3}>
                <TextField
                  onChange={(e) => setId(e.target.value)}
                  name="email"
                  label="아이디"
                  placeholder="전화번호 끝 8자리"
                />

                <TextField
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  label="비밀번호"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="전화번호 끝 4자리"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
              <br />
              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={() => {
                  fetch(`${BACK}/login`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id,
                      password,
                    }),
                  })
                    .then((res) => {
                      console.log(res.status);
                      if (res.status === 200) {
                        return res.json();
                      }
                      throw Error('err');
                    })
                    .then((data) => {
                      if (data.type) {
                        localStorage.setItem('token', data.token);
                        localStorage.setItem('id', data.id);
                        localStorage.setItem('name', data.name);
                        localStorage.setItem('type', data.type);
                        window.location.href = '/';
                      } else {
                        console.log(data);
                      }
                    })
                    .catch((err) => console.log({ err }));
                }}
              >
                로그인
              </LoadingButton>
            </>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
